module.exports = __webpack_public_path__ + "img/c-2.63d0dc9e.jpg";